import { useMutation } from '@apollo/client';
import {
  IssueCableCodeInput,
  IssueCableCodesResult,
  IssueCableInput,
  IssueCableTermsInput,
  IssueCableTermsResult,
  IssueCablesResult,
  IssueEquipmentCodeInput,
  IssueEquipmentCodesResult,
  IssueEquipmentInput,
  IssueEquipmentsResult,
  IssueFireAreaInput,
  IssueFireAreasResult,
  IssueJumperInput,
  IssueJumpersResult,
  IssueProjectInput,
  IssueProjectsResult,
  IssueRacewayCodeInput,
  IssueRacewayCodesResult,
  IssueRacewayInput,
  IssueRacewaysResult,
  IssueRouteInput,
  IssueRoutesResult,
  IssueSeparationGroupCompatibilitiesResult,
  IssueSeparationGroupCompatibilityInput,
  IssueServiceLevelCompatibilitiesResult,
  IssueServiceLevelCompatibilityInput,
  IssueServiceLevelRacewayInput,
  IssueServiceLevelRacewaysResult,
  MetadataTableName,
} from '@bechtel/sr-types';
import {
  ISSUE_CABLES,
  ISSUE_CABLE_CODES,
  ISSUE_CABLE_TERMS,
  ISSUE_EQUIPMENTS,
  ISSUE_EQUIPMENT_CODES,
  ISSUE_FIRE_AREAS,
  ISSUE_JUMPERS,
  ISSUE_PROJECTS,
  ISSUE_RACEWAYS,
  ISSUE_RACEWAY_CODES,
  ISSUE_SEPARATION_GROUP_COMPATIBILITIES,
  ISSUE_SERVICE_LEVEL_COMPATIBILITIES,
  ISSUE_SERVICE_LEVEL_RACEWAYS,
} from '~/gql';
import { ISSUE_ROUTES } from '~/gql/route';

export function useChangeManagement(name: string): any {
  // Set up all the issue mutation here, based on commodity type return the mutation object
  const equimentIssueResponse = useMutation<
    { issueEquipments: IssueEquipmentsResult },
    { issueEquipmentsInput: IssueEquipmentInput[] }
  >(ISSUE_EQUIPMENTS);

  const equimentCodeIssueResponse = useMutation<
    { issueEquipmentCodes: IssueEquipmentCodesResult },
    { issueEquipmentCodesInput: IssueEquipmentCodeInput[] }
  >(ISSUE_EQUIPMENT_CODES);

  const cableCodeIssueResponse = useMutation<
    { issueCableCodes: IssueCableCodesResult },
    { issueCableCodesInput: IssueCableCodeInput[] }
  >(ISSUE_CABLE_CODES);

  const racewayCodeIssueResponse = useMutation<
    { issueRacewayCodes: IssueRacewayCodesResult },
    { issueRacewayCodesInput: IssueRacewayCodeInput[] }
  >(ISSUE_RACEWAY_CODES);

  const projectConfigurationIssueResponse = useMutation<
    { issueProjects: IssueProjectsResult },
    { issueProjectsInput: IssueProjectInput[] }
  >(ISSUE_PROJECTS);

  const cableIssuesResponse = useMutation<{ issueCables: IssueCablesResult }, { issueCablesInput: IssueCableInput[] }>(
    ISSUE_CABLES
  );

  const racewayIssueResponse = useMutation<
    { issueRaceways: IssueRacewaysResult },
    { issueRacewaysInput: IssueRacewayInput[] }
  >(ISSUE_RACEWAYS);

  const fireAreaIssueResponse = useMutation<
    { issueFireAreas: IssueFireAreasResult },
    { issueFireAreasInput: IssueFireAreaInput[] }
  >(ISSUE_FIRE_AREAS);

  const jumperIssueResponse = useMutation<
    { issueJumpers: IssueJumpersResult },
    { issueJumpersInput: IssueJumperInput[] }
  >(ISSUE_JUMPERS);

  const serviceLevelCompatibilityIssueResponse = useMutation<
    { issueServiceLevelCompatibilities: IssueServiceLevelCompatibilitiesResult },
    { issueServiceLevelCompatibilityInput: IssueServiceLevelCompatibilityInput[] }
  >(ISSUE_SERVICE_LEVEL_COMPATIBILITIES);

  const separationGroupCompatibilityIssueResponse = useMutation<
    { issueSeparationGroupCompatibilities: IssueSeparationGroupCompatibilitiesResult },
    { issueSeparationGroupCompatibilityInput: IssueSeparationGroupCompatibilityInput[] }
  >(ISSUE_SEPARATION_GROUP_COMPATIBILITIES);

  const serviceLevelRacewayIssueResponse = useMutation<
    { issueServiceLevelRaceways: IssueServiceLevelRacewaysResult },
    { issueServiceLevelRacewayInput: IssueServiceLevelRacewayInput[] }
  >(ISSUE_SERVICE_LEVEL_RACEWAYS);

  const RouteIssueResponse = useMutation<
    { issueCableRoutes: IssueRoutesResult },
    { issueCableRoutesInput: IssueRouteInput[] }
  >(ISSUE_ROUTES);

  const cableTermsIssuesResponse = useMutation<
    { issueCableTerms: IssueCableTermsResult },
    { issueCableTermsInput: IssueCableTermsInput[] }
  >(ISSUE_CABLE_TERMS);

  if (name === MetadataTableName.EQUIPMENT) {
    return equimentIssueResponse;
  } else if (name === MetadataTableName.EQUIPMENT_CODE) {
    return equimentCodeIssueResponse;
  } else if (name === MetadataTableName.CABLE_CODE) {
    return cableCodeIssueResponse;
  } else if (name === MetadataTableName.RACEWAY_CODE) {
    return racewayCodeIssueResponse;
  } else if (name === MetadataTableName.PROJECT) {
    return projectConfigurationIssueResponse;
  } else if (name === MetadataTableName.CABLE) {
    return cableIssuesResponse;
  } else if (name === MetadataTableName.RACEWAY) {
    return racewayIssueResponse;
  } else if (name === MetadataTableName.FIRE_AREA) {
    return fireAreaIssueResponse;
  } else if (name === MetadataTableName.JUMPER) {
    return jumperIssueResponse;
  } else if (name === MetadataTableName.SERVICE_LEVEL_COMPATIBILITY) {
    return serviceLevelCompatibilityIssueResponse;
  } else if (name === MetadataTableName.SEPARATION_GROUP_COMPATIBILITY) {
    return separationGroupCompatibilityIssueResponse;
  } else if (name === MetadataTableName.SERVICE_LEVEL_RACEWAY) {
    return serviceLevelRacewayIssueResponse;
  } else if (name === MetadataTableName.VIA) {
    return RouteIssueResponse;
  } else if (name === MetadataTableName.CABLE_FROM_END || name === MetadataTableName.CABLE_TO_END) {
    return cableTermsIssuesResponse;
  }
  // else if (commodityType === CommodityType.JUMPER) {
  //   return jumperNotesResponse;
  // else if (commodityType === CommodityType.FROMEND) {
  //   return cableFromTermNotesResponse;
  // } else if (commodityType === CommodityType.TOEND) {
  //   return cableToTermNotesResponse;
  // }
  return equimentIssueResponse;
}
